import { InjectionToken } from '@angular/core';

export interface TrustcommanderConfig {
  siteId: string;
  fileNames: {
    [lang: string]: string;
  };
}

export const TRUSTCOMMANDER_CONFIG = new InjectionToken<TrustcommanderConfig | undefined>('TRUSTCOMMANDER_CONFIG');
